import Avatar from 'components/ui/Avatar';

import { NavLink } from 'react-router-dom';
import { useAuth } from 'providers/auth';
import { useTranslation } from 'react-i18next';

const UserMenu = () => {
  const { t } = useTranslation();
  const { me } = useAuth();

  if (!me) {
    return null;
  }

  const names = me.name.split(' ');
  const first_name = names[0];

  return (
    <NavLink to="/profile" style={{ textDecoration: 'none' }} id="user-menu" className="d-flex align-items-center text-capitalize text-dark">
      <div className="p-1">
        <Avatar
          size={32}
          name={me.name}
          email={me.email}
          src={me.profile_image}
          className="user-avatar rounded-circle shadow-sm hover-ouline-primary"
        />
      </div>

      <div className="ms-2" style={{ lineHeight: 1 }}>
        {t('keys.hi')}, {first_name}!
      </div>
    </NavLink>
  );
};

export default UserMenu;
